export default __webpack_public_path__ + "static/media/whatsapp.d5f9a350.svg";